import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';

type UseSearchAlertRequiredFieldsResult = {
  keywords: string | null;
  location: string | null;
};

export const useSearchAlertRequiredFields =
  (): UseSearchAlertRequiredFieldsResult => {
    const { getSearchParameter } = useSearchParameter();

    const keywords = getSearchParameter(SEARCH_STATE_PARAMS.keywords);
    const location = getSearchParameter(SEARCH_STATE_PARAMS.location);

    return { keywords, location };
  };
